import { combineReducers, Reducer } from 'redux';

import waiverToChangeAssociation from './workItem/waiverToChangeAssociationReducer';
import updateState from './workItem/waiverWorkItemUpdateStatusReducer';

import { Action } from '../../types';

const rootReducer: Reducer<any, Action<any>> = combineReducers({
  waiverToChangeAssociation,
  updateState,
});

export default rootReducer;
